import axiosInstance from '@/plugins/axios'
import { appApiUrls } from '../constants/apiUrls'


/**
 * Fetches claims/reimbursements for a specific user
 * @param {string} userId - User Object ID
 * @param {object} params - { year, reimbursementType }
 */
export const getUserReimbursements = (userId, params = {}) => {
  return axiosInstance.get(`${appApiUrls.claim.userReimbursements}/${userId}`, { params })
}

/**
 * Uploads a receipt / invoice document
 * @param {FormData} formData - Contains { attachments, userId, month }
 */
export const uploadReimbursementDocument = (formData) => {
  return axiosInstance.post(appApiUrls.claim.uploadDocument, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * Submits a new reimbursement claim
 * @param {object} payload - Claim payload
 */
export const submitReimbursement = (payload) => {
  return axiosInstance.post(appApiUrls.claim.submitReimbursement, payload)
}

/**
 * Updates / Resubmits an existing reimbursement claim
 * @param {string} id - Claim ID
 * @param {object} payload - Updated claim payload
 */
export const updateReimbursement = (id, payload) => {
  return axiosInstance.put(`${appApiUrls.claim.updateReimbursement}/${id}`, payload)
}

/**
 * Fetches dedicated claim settings (travel modes, per-km rates, allowances, policies)
 * Supports optional branchId parameter for branch-specific overrides
 */
export const getClaimSettings = (params = {}) => {
  return axiosInstance.get(appApiUrls.claim.claimSettings, { params })
}

/**
 * Saves / upserts dedicated claim settings
 * @param {object} payload - Claim setting configuration
 */
export const saveClaimSettings = (payload) => {
  return axiosInstance.post(appApiUrls.claim.claimSettings, payload)
}

/**
 * Adds a comment to a claim for seamless two-way communication
 * @param {string} id - Claim ID
 * @param {string} message - Comment text
 */
export const addClaimComment = (id, message) => {
  return axiosInstance.post(`${appApiUrls.claim.submitReimbursement}/${id}/comment`, { message })
}

